import { I18n } from '@calendly/i18n'
import { AdminIcon } from '@calendly/ui/components/icons'
import { TitleText } from '@calendly/ui/components/typography'
import { colorIconSecondary, colorTextSecondary } from '@calendly/ui/theme'

import { Layout } from 'components/layout'
import { useEventType } from 'features/event_type_provider'

export const Header = () => {
  const { isMETParent } = useEventType()

  return (
    <Layout gap="8">
      {isMETParent && <AdminIcon inline={false} color={colorIconSecondary} />}
      <TitleText size="x-small" color={colorTextSecondary}>
        {isMETParent
          ? I18n.t('publisher.event_type_editor.sections.name.header.managed_title')
          : I18n.t('publisher.event_type_editor.sections.name.header.title')}
      </TitleText>
    </Layout>
  )
}
